import { Component } from '@angular/core';
import { MatIconRegistry } from "@angular/material";
import { DomSanitizer } from "@angular/platform-browser";
import { HttpClientModule } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  public constructor (
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry) {
    //add custom material icons
    matIconRegistry.addSvgIcon('ice-cream', domSanitizer.bypassSecurityTrustResourceUrl('https://firebasestorage.googleapis.com/v0/b/moments-8ba80.appspot.com/o/icons%2Fice-cream.svg?alt=media&token=ab838252-2df8-4951-a030-d76585650791'));
  }



}



// WEBPACK FOOTER //
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/app.component.ts